/**
 * Página: Energia
 */
import SegmentPage from '../../components/SegmentPage'

const segment = {
  name: 'Energia',
  tagline: 'Segurança elétrica em primeiro lugar.',
  description: 'Controle de acesso, EPIs e procedimentos para subestações, usinas e equipes de manutenção elétrica. NR-10 é nossa prioridade.',
  icon: '⚡',
  color: '#EAB308',
  gradient: 'linear-gradient(135deg, #EAB308 0%, #F97316 100%)',
  painPoints: [
    'Trabalho em áreas de alto risco elétrico',
    'Controle de acesso a subestações',
    'Verificação rigorosa de EPIs específicos',
    'Equipes em locais remotos sem conectividade',
    'Compliance NR-10 extremamente rigoroso',
    'Procedimentos de bloqueio e etiquetagem',
  ],
  benefits: [
    'Ponto facial com verificação de EPI obrigatória',
    'Controle de acesso biométrico a áreas restritas',
    'Modo offline para locais sem internet',
    'Verificação de EPIs de alta tensão',
    'Integração com sistemas de permissão de trabalho',
    'Auditoria completa de acessos',
  ],
  nrs: ['NR-10', 'NR-35', 'NR-6', 'NR-33', 'NR-12'],
  stats: [
    { value: '0', label: 'Acidentes Elétricos' },
    { value: '100%', label: 'NR-10' },
    { value: '99.9%', label: 'Uptime' },
    { value: '-75%', label: 'Desvios' },
  ],
  testimonial: {
    quote: 'Em 2 anos de WorkStream, zero acidentes elétricos. Antes eram 3-4 por ano. Não tem preço.',
    author: 'Eng. Paulo Roberto',
    role: 'Diretor de Segurança',
    company: 'EnergiaSul',
  },
}

export default function Energia() {
  return <SegmentPage segment={segment} />
}

